import { refreshSession } from './BaseService';
import { getToken } from './tokenStore';

// Close code the backend uses when the first message is not a valid token.
const WS_UNAUTHORIZED = 4401;

// The token never goes in the URL. It is the first message after connecting,
// and the server closes the socket if it does not arrive within 5 seconds.
export function sendAuth(event) {
    event.target.send(JSON.stringify({ type: 'auth', token: getToken() }));
}

// The access token may have expired since the last connect. Refresh it, and
// the reconnect that follows sends the new one.
export function onSocketClose(event) {
    if (event.code === WS_UNAUTHORIZED) refreshSession().catch(() => {});
}

// A cleared token means the session is gone: stop retrying.
export function shouldReconnect() {
    return getToken() !== null;
}
